import { Box, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import CalendarViewWeek from "@mui/icons-material/CalendarViewWeek";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import Groups from "@mui/icons-material/Groups";
import Today from "@mui/icons-material/Today";
import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { Hint } from "./Hint";
import { useIsPlainAdmin, useWorkspace } from "./Workspace";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";

export const navWidth = 200;

type NavItem = {
    label: string;
    to: string;
    icon: ReactNode;
}

export function NavList(props: { onNavigate: () => void }) {
    const loc = useLocation();
    const ws = useWorkspace();
    const plainAdmin = useIsPlainAdmin();

    // the admin account is on no team, so it has only the admin page
    const items: NavItem[] = plainAdmin ? [
        { label: "Admin", to: "/admin", icon: <AdminPanelSettings fontSize="small" /> },
    ] : [
        { label: "Today", to: ws.path("/tasks/day"), icon: <Today fontSize="small" /> },
        { label: "Week", to: ws.path("/tasks/calendar") + "?mode=week", icon: <CalendarViewWeek fontSize="small" /> },
        { label: "Projects", to: ws.path("/projects"), icon: <FolderOutlined fontSize="small" /> },
        { label: "Teams", to: ws.team ? ws.path("/team") : ws.path("/teams"), icon: <Groups fontSize="small" /> },
    ];

    return (
        <List dense disablePadding>
            {!plainAdmin && <WorkspaceSwitcher onNavigate={props.onNavigate} />}

            <div style={{ height: 8 }} />
            {items.map(item => (
                <ListItemButton
                    key={item.label}
                    component={Link}
                    to={item.to}
                    selected={loc.pathname === item.to.split("?")[0]}
                    onClick={props.onNavigate}
                >
                    <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.label} />
                </ListItemButton>
            ))}

            {/* a user on their personal team alone may not know they can share */}
            {!plainAdmin && !ws.loading && ws.teams.every(team => team.personal) && (
                <Box sx={{ p: 1, pt: 2 }}>
                    <Hint flag="hint-team">
                        To share tasks with other people, click Workspace above and select New team.
                    </Hint>
                </Box>
            )}
        </List>
    );
}
